angular.module('impactx.cscontract').controller('CSContractBasicListForTenderCtrl', [
    '$scope',
    '$redirect',
    '$controller',
    '$routeParams',
    'PartialDialogsService',
    CSContractBasicListForTenderCtrl]);

function CSContractBasicListForTenderCtrl($scope, $redirect, $controller, $routeParams, PartialDialogsService) {
    var mainCtrl = $controller('CSContractListCtrl', {});
    PartialDialogsService.setCurrentList(PartialDialogsService.TYPE.CONTRACT, 'cscontractlist/tender/'+($routeParams.tenderId ? $routeParams.tenderId : 0));
    mainCtrl.meta = {
        rowTemplate: 'modules/cscontract/templates/cscontractlist.row.tmpl.html',
        filtersTemplate: 'modules/cscontract/templates/cscontractlist.filters.tmpl.html',
        endpoint: '/cscontract/listfortender',
        ctrl: mainCtrl,
        id: "cscontractlistfortender",
        params: {'tenderId': $routeParams.tenderId ? $routeParams.tenderId : 0},
        buttonDefinition: mainCtrl.buttonDefinition,
        excelParams: {
            params: [{param: 'LotId', intValue: 0},
                {param: 'TenderId', intValue: $routeParams.tenderId ? $routeParams.tenderId : 0}]
        },
        isSelectAble: true,
        valuesInteger: [{name: "CSC_Id", value: 0}]
    };
    this.getMeta = function ()
    {
        return mainCtrl.meta;
    };
    mainCtrl.contractType = "basic";
    $scope.$watch(function() {
        return mainCtrl.contractType;
    }, function(newValue) {
        if(newValue == "model") {
            $redirect.redirectTo(null, "/cscontractmodellist/tender/" + $routeParams.tenderId);
        }
    });
}